import React from 'react';
import PropTypes from 'prop-types';

import { HomecardLabel } from '@spotahome/ui-library';
import {
  useSoyuzFlag,
  useSoyuzExperiment,
  trans
} from '@spotahome/soyuz/client';

import OfferIcon from '../icons/Offer';
import './HomeCardLabels.scss';

const labelOptions = {
  checkedLabel: {
    name: 'checked',
    content: () => trans('homecard.label.checked')
  },
  virtualTourLabel: {
    name: 'virtualTour',
    content: () => trans('homecard.label.virtual-tour')
  },
  topLandordLabel: {
    name: 'topLandlord',
    content: () => trans('homecard.label.top_lister')
  },
  offerLabel: {
    name: 'offer',
    content: () => trans('homecard.label.offer'),
    icon: () => <OfferIcon />
  }
};

const HomeCardLabels = ({ checked, isSuperlister, hasOffer }) => {
  const {
    checkedLabel,
    virtualTourLabel,
    topLandordLabel,
    offerLabel
  } = labelOptions;

  const showVirtualTourLabel =
    useSoyuzExperiment('VirtualTourLabel').get('behaviour') === 'variant';

  const showLandlordPropertyOffersFlag = useSoyuzFlag(
    'ShowLandlordPropertyOffers'
  );

  const showOfferLabel = showLandlordPropertyOffersFlag.isOn() && hasOffer;

  return (
    <div className="homecard-labels">
      {showVirtualTourLabel && (
        <HomecardLabel
          renderContent={virtualTourLabel.content}
          labelType="checked"
        />
      )}
      {!showVirtualTourLabel && checked && (
        <HomecardLabel
          renderContent={checkedLabel.content}
          labelType="checked"
        />
      )}
      {isSuperlister && (
        <HomecardLabel
          renderContent={topLandordLabel.content}
          labelType="top-landlord"
        />
      )}
      {showOfferLabel && (
        <HomecardLabel
          data-test="homecard-offer-label"
          renderContent={offerLabel.content}
          renderIcon={offerLabel.icon}
          labelType="offer"
        />
      )}
    </div>
  );
};

HomeCardLabels.propTypes = {
  checked: PropTypes.bool.isRequired,
  isSuperlister: PropTypes.bool.isRequired,
  hasOffer: PropTypes.bool.isRequired
};

export const generateHomeCardLabels = ({
  checked,
  isSuperlister,
  hasOffer
}) => () => (
  <HomeCardLabels
    checked={checked}
    isSuperlister={isSuperlister}
    hasOffer={hasOffer}
  />
);

export default generateHomeCardLabels;
